<template>
  <v-card class="pa-0 mb-16 beneficiary-card">
    <!-- Confirm Your Changes -->
    <v-card-title class="text-wrap">
      <h1 role="heading" aria-level="2" class="text-h1">
        {{ $t('L_confirm_your_changes') }}
      </h1>
    </v-card-title>

    <v-card-text>
      <!-- Texts and Instructions -->
      <v-row class="pt-4">
        <v-col cols="12">
          <p class="font-weight-bold text-body-1">
            {{ $t('L_please_review_and_confirm_that_this_information_is_correct') }}
          </p>
          <p class="mt-4 text-body-1">
            {{
              $t(
                'L_the_beneficiaries_listed_below_will_be_used_to_update_this_policy_and_will_replace'
              )
            }}
          </p>
          <p
            class="mt-4 text-body-1"
            v-html="$t('L_if_You_need_to_make_changes_select_the_back_button')"
          />
        </v-col>
      </v-row>

      <!-- PRIMARY SECTION-->
      <div class="px-0">
        <!-- PRIMARY - Main Header -->
        <v-row class="blueBoxInsured mt-4">
          <v-col cols="12">
            <h1 class="text-h1 font-weight-regular">
              {{ $t('L_policy_insured') }}
              <span class="font-weight-bold"> {{ primaryInsured }}</span>
            </h1>
          </v-col>
        </v-row>

        <!-- PRIMARY - Primary Benef Header -->
        <div class="lineSeparation d-flex align-center mt-6 mb-3 pb-3">
          <p class="text-body-1 font-weight-bold text-left pl-0 flex-grow-1 header-title-width">
            {{ $t('L_primary_beneficiary') }}
          </p>
          <v-spacer></v-spacer>
          <p class="text-body-1 font-weight-bold text-left px-0 allocation-percentage-width">
            {{ $t('L_allocation_percentage') }}
          </p>
        </div>

        <!-- PRIMARY - Primary Beneficiary - Allocation % -->
        <div
          v-for="(beneficiary, index) in beneficiaryPrimary"
          :key="beneficiary.beneKeyId + 'primaryBeneficiary' + index"
          :class="Number(index) % 2 === 0 ? 'bkgrnd-color-blue-white' : 'bkgrnd-color-white'"
          class="layoutHeightVertCenterData lineSeparation pt-2 pb-5 d-flex align-center"
        >
          <div class="textOverflow text-left text-body-1 pl-0 header-title-width">
            <span v-if="beneficiary.irrevocable">
              <v-icon color="#4e4949c7" :icon="mdiLock" />
            </span>
            {{ getFullNameForDisplayWithLocale(beneficiary.fullName) }}
          </div>
          <v-spacer></v-spacer>
          <div class="text-left text-body-1 pl-0 pr-0 allocation-percentage-width">
            {{ beneficiary.beneficiaryPercent }} %
          </div>
        </div>

        <!-- PRIMARY - Contingent Benef Header -->
        <div class="lineSeparation d-flex align-center mt-6 mb-3 pb-3">
          <p class="text-body-1 font-weight-bold text-left pl-0 flex-grow-1 header-title-width">
            {{ $t('L_contingent_beneficiary') }}
          </p>
          <v-spacer></v-spacer>
          <p class="text-body-1 font-weight-bold text-left px-0 allocation-percentage-width">
            {{ $t('L_allocation_percentage') }}
          </p>
        </div>

        <!-- PRIMARY - Contingent Benef - Allocation % -->
        <div
          v-for="(beneficiary, index) in beneficiaryPrimaryContingent"
          :key="beneficiary.beneKeyId + 'beneficiaryPrimaryContingent' + index"
          :class="Number(index) % 2 === 0 ? 'bkgrnd-color-blue-white' : 'bkgrnd-color-white'"
          class="layoutHeightVertCenterData lineSeparation pt-4 pb-5 d-flex align-center"
        >
          <div class="textOverflow text-left text-body-1 pl-0 header-title-width">
            <span v-if="beneficiary.irrevocable">
              <v-icon color="#4e4949c7" :icon="mdiLock" />
            </span>
            {{ getFullNameForDisplayWithLocale(beneficiary.fullName) }}
          </div>
          <v-spacer></v-spacer>
          <div class="text-left text-body-1 pl-0 pr-0 allocation-percentage-width">
            {{ beneficiary.beneficiaryPercent }} %
          </div>
        </div>
      </div>
      <!-- TODO: Copy Code from Primary / REUSE components -->
      <!-- SPOUSE SECTION-->
      <div v-if="beneficiarySpouse.length > 0" class="px-0">
        <!-- SPOUSE - Main Header -->
        <v-row class="blueBoxInsured mt-8">
          <v-col cols="12">
            <h1 class="text-h1 font-weight-regular">
              {{ $t('L_policy_spouse_insured')
              }}<span class="font-weight-bold"> &nbsp;{{ spouseInsured }}</span>
            </h1>
          </v-col>
        </v-row>

        <!-- SPOUSE - Primary Benef Header-->
        <div class="lineSeparation d-flex align-center mt-6 mb-3 pb-3">
          <p class="text-body-1 font-weight-bold text-left pl-0 flex-grow-1 header-title-width">
            {{ $t('L_primary_beneficiary') }}
          </p>
          <v-spacer></v-spacer>
          <p class="text-body-1 font-weight-bold text-left px-0 allocation-percentage-width">
            {{ $t('L_allocation_percentage') }}
          </p>
        </div>

        <!-- SPOUSE - Primary Beneficiary - Allocation % -->
        <div
          v-for="(beneficiary, index) in beneficiarySpouse"
          :key="beneficiary.beneKeyId + 'primaryBeneficiary' + index"
          :class="Number(index) % 2 === 0 ? 'bkgrnd-color-blue-white' : 'bkgrnd-color-white'"
          class="layoutHeightVertCenterData lineSeparation pt-4 pb-5 d-flex align-center"
        >
          <div class="textOverflow font-size--14 pt-2 pb-2 text-left pl-0 header-title-width">
            <span v-if="beneficiary.irrevocable">
              <v-icon color="#4e4949c7" :icon="mdiLock" />
            </span>
            {{ getFullNameForDisplayWithLocale(beneficiary.fullName) }}
          </div>
          <v-spacer></v-spacer>
          <div class="font-size--14 pt-2 pb-2 text-left pl-0 pr-0 allocation-percentage-width">
            {{ beneficiary.beneficiaryPercent }} %
          </div>
        </div>

        <!-- SPOUSE - Contingent Benef Header -->
        <div class="lineSeparation d-flex align-center mt-6 mb-3 pb-3">
          <p class="text-body-1 font-weight-bold text-left pl-0 flex-grow-1 header-title-width">
            {{ $t('L_contingent_beneficiary') }}
          </p>
          <v-spacer></v-spacer>
          <p class="text-body-1 font-weight-bold text-left px-0 allocation-percentage-width">
            {{ $t('L_allocation_percentage') }}
          </p>
        </div>

        <!-- SPOUSE - Contingent Benef - Allocation % -->
        <div
          row
          wrap
          v-for="(beneficiary, index) in beneficiarySpouseContingent"
          :key="beneficiary.beneKeyId + 'beneficiaryPrimaryContingent' + index"
          :class="Number(index) % 2 === 0 ? 'bkgrnd-color-blue-white' : 'bkgrnd-color-white'"
          class="layoutHeightVertCenterData lineSeparation pt-4 pb-5 d-flex align-center"
        >
          <div class="font-size--14 pt-2 pb-2 text-left textOverflow pl-0 header-title-width">
            <span v-if="beneficiary.irrevocable">
              <v-icon color="#4e4949c7" :icon="mdiLock" />
            </span>
            {{ getFullNameForDisplayWithLocale(beneficiary.fullName) }}
          </div>
          <v-spacer></v-spacer>
          <div class="font-size--14 pt-2 pb-2 text-left pl-0 pr-0 allocation-percentage-width">
            {{ beneficiary.beneficiaryPercent }} %
          </div>
        </div>
      </div>
    </v-card-text>

    <v-divider class="my-6 solidBlack paddingLRDesktop" />

    <!-- Disclaimer Section-->
    <v-container>
      <v-row class="px-4">
        <v-col cols="12">
          <span>
            <v-icon class="mr-2" color="#4e4949c7" :icon="mdiLock" />
          </span>
          <span
            class="font-size--14"
            v-html="$t('L_note_beneficiaries_with_this_icon_represent_an')"
          />
        </v-col>
        <v-col cols="12">
          <span class="font-size--14 font-weight-regular">
            {{
              $t('L_the_above_beneficiaries_will_be_recorded_as', {
                serviceLine: customerServicePhoneNum,
              })
            }}
            <span @click="openIrrevocableChangeForm" class="help-link" v-if="locale === 'en_US'">{{
              $t('L_irrevocable_beneficiary_designation_and_change_form')
            }}</span>
          </span>
        </v-col>
      </v-row>
      <OnexDialog
        :type="'success'"
        :is-persistent="true"
        v-model="displaySuccessMessage"
        max-width="700"
        class="aboveDialog"
        :show-close-button="false"
      >
        <template #title>
          <span>
            {{ $t('L_Beneficiary_changes_completed') }}
          </span>
        </template>
        <template #text>
          <slot>
            <!-- List of Issues -->
            <v-col cols="12">
              <p class="text-left">
                {{ $t('L_your_beneficiary_changes_were_successfully_applied_to_your_life_policy') }}
              </p>
            </v-col>
          </slot>
        </template>
        <template #yesBtn>
          <span @click="closeDialogAndResetBeneficiaryStep">{{ $t('L_OK') }}</span>
        </template>
      </OnexDialog>
    </v-container>

    <v-card-actions>
      <!-- Button section-->
      <v-row class="d-flex align-center justify-center pt-8 pb-4 mx-0">
        <v-col cols="12" sm="6" md="4" class="pr-4">
          <OnexButton block variant="outlined" @click="goBackToMyBeneficiary" size="large">
            {{ $t('L_back') }}
          </OnexButton>
        </v-col>
        <v-col cols="12" sm="6" md="4" class="pr-4">
          <OnexButton block @click="confirmAndSubmit" :disabled="!isSubmitButtonReady" size="large">
            <span>{{ $t('L_confirm_and_submit') }}</span>
          </OnexButton>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import DynatraceClient from '@/plugins/dynatracePlugin';
import { mapActions, mapState, mapStores } from 'pinia';
import { useGlobalStore } from '@/stores/global/global.store';
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import { mdiCheckCircleOutline, mdiClose, mdiLock } from '@mdi/js';
import { OnexButton, OnexDialog, OnexPassword } from '@primerica/onex-ui-lib';
import { RouteNames } from '@/router/routeNames';

export const contactInfo = [
  { number: 8002574725, phone: '(800) 257-4725', email: 'plic@primerica.com' },
  { number: 8002574725, phone: '(800) 257-4725', email: 'nblic@primerica.com' },
  { number: 8003877976, phone: '(800) 387-7976', email: 'plicc_cn@primerica.com' },
];

const componentOptions: ComponentOptions = {
  name: 'ConfirmBeneficiary',
  components: {
    OnexButton,
    OnexDialog,
    OnexPassword,
  },
  data: () => ({
    displaySuccessMessage: false,
    isSubmitButtonReady: true,
    mdiLock,
    mdiCheckCircleOutline,
    mdiClose,
    currentPassword: '',
  }),
  computed: {
    ...mapStores(usePolicyStore),
    ...mapState(useGlobalStore, { locale: 'getLocale' }),
    ...mapState(usePolicyStore, [
      'beneficiaryStep',
      'currentPolicy',
      'policies',
      'beneficiaryPrimary',
      'beneficiaryPrimaryContingent',
      'beneficiarySpouse',
      'beneficiarySpouseContingent',
      'selectedPolicyIndex',
    ]),
    customerServicePhoneNum() {
      if (this.locale === 'en_US') {
        return '(800) 257-4725';
      } else if (this.locale === 'en_CA') {
        return '(800) 387-7876';
      } else if (this.locale === 'fr_CA') {
        return '(800) 265-4804';
      }
      return '(800) 257-4725';
    },
    primaryInsured() {
      const firstName = this.currentPolicy?.primaryInsured?.firstName ?? '';
      const lastName = this.currentPolicy?.primaryInsured?.lastName ?? '';
      return `${firstName} ${lastName}`.trim();
    },
    spouseInsured() {
      if (this.currentPolicy?.data?.spouseLastName) {
        return `${this.currentPolicy?.data?.spouseFirstName} ${this.currentPolicy?.data?.spouseLastName}`;
      }
      return this.$t('L_policy_beneficiaries_spouse');
    },
  },
  methods: {
    ...mapActions(usePolicyStore, ['setBeneficiaries']),
    openIrrevocableChangeForm() {
      if (this.locale === 'fr_CA') {
        window.open(window.appConfig.life.Canada_French_Irrevocable_change_form, '_blank');
      } else if (this.locale === 'en_CA') {
        window.open(window.appConfig.life.Canada_English_Irrevocable_change_form, '_blank');
      } else {
        window.open(window.appConfig.life.US_Irrevocable_change_form, '_blank');
      }
    },
    async closeDialogAndResetBeneficiaryStep() {
      this.policyStore.scrollToPolicyDetails = 'beneficiary';
      this.displaySuccessMessage = false;
      this.policyStore.beneficiaryStep = -1;
      await this.$router.push({
        name: RouteNames.POLICY_DETAILS,
        params: { contractId: this.selectedPolicyIndex },
      });
    },
    getFullNameForDisplayWithLocale(fullName: string) {
      let retFullName = fullName;
      if (this.locale === 'fr_CA' || this.locale === 'es_US') {
        if (fullName === 'Estate') {
          retFullName = this.$t('L_estate');
        } else if (fullName === 'All Children Equally') {
          retFullName = this.$t('L_all_children_equally');
        } else {
          return retFullName;
        }
      }
      return retFullName;
    },
    async confirmAndSubmit() {
      this.isSubmitButtonReady = false;
      try {
        const i = DynatraceClient.enterAction('confirmBeneficiaries_submit');
        DynatraceClient.leaveAction(i);
        const tempDynatraceString = `PC2_ConfirmBenf_Submit_Policynum-${this.currentPolicy?.contractId}`;

        const response = await this.setBeneficiaries();
        if (
          response &&
          (response?.status === 200 || response?.status === 201 || response?.status === 204)
        ) {
          this.displaySuccessMessage = true;
        }
        const j = DynatraceClient.enterAction(tempDynatraceString);
        DynatraceClient.leaveAction(j);
      } catch (_error) {
        /* empty */
        this.isSubmitButtonReady = true;
      }
      this.isSubmitButtonReady = true;
    },
    goBackToMyBeneficiary() {
      this.policyStore.beneficiaryStep = 1;
      this.$router.push({
        name: RouteNames.BENEFICIARY_STEP,
        params: {},
      });
      return;
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.blueBoxInsured {
  background-color: #d2dee9;
}
.lineSeparation {
  border-bottom: 1px solid #cccccc;
  margin-left: 0px;
  margin-right: 0px;
}
#ra_external {
  width: 100%;
}
#mainIframe {
  overflow-y: scroll;
}
.paddingLRDesktop {
  padding-left: 20px;
  padding-right: 20px;
}
.dialog_header_label {
  font-size: 28px;
  font-weight: bold;
  color: #333333;
}
.dialog_header_label_mobile {
  font-size: 14px;
  font-weight: bold;
  color: #333333;
}
.dialog_close_icon {
  font-size: 40px !important;
}
.dialog_close_icon_mobile {
  font-size: 25px !important;
  margin-top: -5px;
}
.dialog_body_text {
  font-size: 18px;
  font-weight: normal;
  padding-bottom: 80px;
}
.dialog_body_text_mobile {
  font-size: 13px;
  font-weight: normal;
  padding-bottom: 40px;
}
.dialog_button {
  margin-top: 50px;
  font-size: 20px;
  font-weight: bold;
}
.dialog_button_mobile {
  margin-top: 30px;
  font-size: 14px;
  font-weight: bold;
}
.buttonFormat {
  width: 300px;
  height: 44px;
  font-size: 18px;
  font-weight: 600;
}
.buttonFormat_mobile {
  width: 180px;
  height: 44px;
  font-size: 14px;
  font-weight: 600;
}
.solidBlack {
  border: 2px solid black;
  margin-top: 40px;
}
.greenbar {
  border-top: 8px solid #0b8d1f;
}
.help-link {
  font-weight: 600;
  color: #02579e !important;
  text-decoration: none;
  cursor: pointer;
}
.beneficiary-card.v-card {
  height: 100%;
  position: relative;
}
.allocation-percentage-width {
  width: 136.5px;
}

@media (max-width: 440px) {
  .beneficiary-card.v-card {
    width: 100vw;
    left: -1rem;
  }
  .header-title-width {
    width: 225px;
  }
  .allocation-percentage-width {
    width: 99.5px;
  }
}
</style>
